import { observer }                 from 'mobx-react-lite';
import View                         from '@widesk-ui/components/View';
import Alert                        from '@widesk-ui/components/Alert';
import Button                       from '@widesk-ui/components/Button';
import Spin                         from '@widesk-ui/components/Spin';
import useDesignTokens              from '@/hooks/useDesignTokens';
import { describeRegion }           from '@/TokamapEditor/helpers/planAnalysisRegion';
import planImportStore              from '@/TokamapEditor/planImport/planImportStore';
import PlanRegionCanvas             from '@/TokamapEditor/planImport/PlanRegionCanvas';
import { PLAN_DETECTION_STEP_LABELS } from '@/TokamapEditor/planImport/planDetectionWait';

const PlanRegionStep = observer(() => {
	const tokens = useDesignTokens();
	const { source, region, detecting, progress, detection } = planImportStore;
	if (!source) return null;

	const suggested = detection?.source.suggestedRegion ?? null;

	return (
		<View row flex style={{ minHeight: 0 }}>
			<PlanRegionCanvas
				source={source}
				region={region}
				disabled={detecting}
				onChange={next => planImportStore.setRegion(next)}
			>
				{detecting && (
					<View
						center
						gap={12}
						style={{
							position: 'absolute',
							inset: 0,
							background: `color-mix(in srgb, ${tokens.surface.elevated} 70%, transparent)`,
						}}
					>
						<Spin size="large" />
						<View size={14} style={{ fontWeight: 600 }}>
							{progress ? PLAN_DETECTION_STEP_LABELS[progress.step] : 'Détection lancée…'}
						</View>
						{progress && (
							<View size={12} color={tokens.text.secondary}>
								Étape {progress.current} sur {progress.total}
							</View>
						)}
					</View>
				)}
			</PlanRegionCanvas>

			<View
				gap={16}
				style={{ width: 360, padding: 20, borderLeft: `1px solid ${tokens.border.subtle}`, overflowY: 'auto' }}
			>
				<View gap={6}>
					<View size={15} style={{ fontWeight: 600 }}>Zone d’analyse</View>
					<View size={13} color={tokens.text.secondary}>
						Entourez la partie utile du plan, sans cartouche ni légende : la détection ne regardera
						qu’elle. Sans zone, tout le plan est analysé.
					</View>
				</View>

				<View
					p={12}
					gap={4}
					style={{ borderRadius: 8, background: tokens.surface.subtle }}
				>
					<View size={12} color={tokens.text.secondary}>Zone retenue</View>
					<View size={13}>{describeRegion(region, source)}</View>
				</View>

				<View row gap={8} wrap>
					<Button disabled={detecting || !region} onClick={() => planImportStore.setRegion(null)}>
						Tout le plan
					</Button>
					{suggested && (
						<Button disabled={detecting} onClick={() => planImportStore.setRegion(suggested)}>
							Zone suggérée
						</Button>
					)}
				</View>

				{detection && (
					<Alert
						type="warning"
						showIcon
						message="Relancer la détection remet le tri à zéro"
						description="Les formes sont renumérotées à chaque détection : les choix déjà faits ne peuvent pas être repris."
					/>
				)}

				{planImportStore.error && <Alert type="error" showIcon message={planImportStore.error} />}
			</View>
		</View>
	);
});

export default PlanRegionStep;
